export default {
  getProducts: state => state.products
}
